export default {
  // 页面标题
  黑名单列表: "黑名單列表",
  添加黑名单: "添加黑名單",
  供应商黑名单: "供應商黑名單",

  // 表单字段
  移入黑名单原因: "移入黑名單原因",
  移出黑名单原因: "移出黑名單原因",
  请输入移入黑名单原因: "請輸入移入黑名單原因",
  请输入移出黑名单原因: "請輸入移出黑名單原因",
  请输入: "請輸入",

  // 表格列
  供应商名称: "供應商名稱",
  供应商名称中文: "供應商名稱（中文）",
  供应商名称英文: "供應商名稱（英文）",

  // 操作按钮
  申请移出黑名单: "申請移出黑名單",

  // 成功提示
  删除成功: "刪除成功",
  移入申请已提交: "移入申請已提交",
  移出申请已提交: "移出申請已提交",
};
